import { render } from "./imageAndTextTemplate.vue?vue&type=template&id=b566e04a&scoped=true"
import script from "./imageAndTextTemplate.vue?vue&type=script&lang=js"
export * from "./imageAndTextTemplate.vue?vue&type=script&lang=js"

import "./imageAndTextTemplate.vue?vue&type=style&index=0&id=b566e04a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\niso\\Documents\\repos\\medrina-everhouse-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b566e04a"]])

export default __exports__